import { useState } from "react";
import SpecialColorSliderElement from "./SpecialColorSliderElement";

export default function SpecialColorSlider({
  products,
  page,
  setActiveProduct,
  activeSku,
}) {
  // console.log(products);
  const [showColors, setShowColors] = useState("hideColor");
  const siteInfo = window.wpProductFilter.siteInfo;
  const plpPageLayout = siteInfo.plpPageLayout;
  const maxProduct = plpPageLayout !== "normal" ? 1000 : 5;
  return (
    <div class="slides row special_slides">
      {products?.map((product, index) => {
        return page === "plp" ? (
          index < maxProduct && (
            <SpecialColorSliderElement
              key={index}
              count={index}
              product={product}
              page={page}
              setActiveProduct={setActiveProduct}
              totalProducts={products.length}
              showColors={showColors}
              setShowColors={setShowColors}
              activeSku={activeSku}
            />
          )
        ) : (
          <SpecialColorSliderElement
            key={index}
            count={index}
            product={product}
            page={page}
            setActiveProduct={setActiveProduct}
            totalProducts={products.length}
            showColors={showColors}
            setShowColors={setShowColors}
            activeSku={activeSku}
          />
        );
      })}
    </div>
  );
}
